import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  breakdown: {},
  applicationInitalData: {},
  documents: [],
  property: {},
  brokers: [],
  instalmentPlanList: [],
  buyers: [],
  representativeDetails: [],
  totalSellingPercentage: 0,
  totalBuyingPercentage: 0,
  applicationId: null,
  applicationType: '',
  propertyDocuments: null,
  contractDetails: {},
  updatePercentbuyer: [],
  locale: localStorage.getItem('lang'),
  nationalities: [],
  buyerList: [],
  query: null,
};

export default function buyersListReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.FETCH_NATIONALITIES:
      return {
        ...state,
        nationalities: get(action.payload, 'nationalities', []),
      };
    case types.BUYER_LIST_OPERATION_START:
      return {
        ...state,
        loading: true,
        error: null,
        buyerList: [],
      };
    case types.BUYER_LIST_OPERATION_END:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
      };
    case types.FETCH_BUYER_LIST:
      return {
        ...state,
        loading: false,
        error: null,
        query: get(action.payload, 'query', null),
        buyerList: get(action.payload, 'buyerList', []),
      };
    case types.ON_PROCEED_VALIDATION_START:
      return {
        ...state,
        loading: true,
        error: null,
        isExpired: false,
        buyerSelected: null,
      };
    case types.ON_PROCEED_VALIDATION:
      return {
        ...state,
        loading: false,
        error: null,
        isExpired: get(action.payload, 'isExpired', false),
        buyerSelected: get(action.payload, 'buyerSelected', null),
        addBuyerModal: get(action.payload, 'addBuyerModal', null),
      };
    case types.ON_PROCEED_VALIDATION_END:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
      };
    case types.CLOSE_BUYER_MODAL:
      return {
        ...state,
        addBuyerModal: get(action.payload, 'addBuyerModal', false),
        buyerSelected: get(action.payload, 'buyerSelected', null),
        documents: [],
      };
    case types.UPLOAD_BUYER_DOCUMENT_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_BUYER_DOCUMENT:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.UPLOAD_BUYER_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
      };
    case types.ADD_BUYER_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
